import { useMemo } from "react";
import { useLockList } from "../api/lock.api";
import { Entity } from "../common/types/entity";
import { getLockDate, isLocked } from "../helpers/lock";
import { Lock } from "../common/types/lock";

export function useNonLockedList<T extends { date: Date; entity: Entity }>(
    list?: T[],
): T[] {
    const uniqueEntityIds = useMemo(
        () => [...new Set((list ?? []).map((l) => l.entity.id))],
        [list],
    );
    const locks = useLockList(uniqueEntityIds);
    const entityLockMap: Map<number, Lock> = useMemo(() => {
        const map = new Map();
        locks.forEach((lock) => {
            if (lock) {
                map.set(lock.entityId, lock);
            }
        });

        return map;
    }, [locks]);

    return useMemo(
        () =>
            (list ?? []).filter((l) => {
                const lock = entityLockMap.get(l.entity.id);
                const lockDate = getLockDate([lock]);
                return !isLocked(lockDate, l.date);
            }),
        [list, entityLockMap],
    );
}
